import { useState } from 'react';
import { ComponentLocations } from 'src/analytics/trackingTypes';
import { Button, Modal } from 'src/components';

export const AddDomains = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <Modal.Root open={isOpen} onOpenChange={(newState) => setIsOpen(newState)}>
      <Modal.Trigger asChild>
        <Button
          variant="primary"
          className="w-full whitespace-nowrap ls:w-fit"
          analytics={{
            action: 'open add domains modal',
            text: 'Add domains',
            location: ComponentLocations.ENTERPRISE.DOMAINS_PAGE,
          }}
        >
          Add domains
        </Button>
      </Modal.Trigger>

      <Modal.Content className="flex max-w-3xl flex-col gap-24"></Modal.Content>
    </Modal.Root>
  );
};
